import ConfirmModal from "components/shared-components/ConfirmModal";
import { TENANT_CODE } from "constants/TennantConstant";
import jwt_decode from "jwt-decode";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import {
  AUTH_TOKEN,
  ROLE_EINVOICE_CUA_HANG,
  ROLE_EINVOICE_KE_TOAN,
} from "store/auth/login/actionTypes";
import DetailInvoice from "./DetailInvoice";
import PDFViewModal from "./modal/PDFViewModal";
import { issueInvoicePageViewList } from "./utils";

const DetailInvoicePage = () => {
  const { id: idDetail } = useParams();
  const history = useHistory();
  const [dataDetail, setDataDetail] = useState({});
  const [detailModal, setDetailModal] = useState(false);

  const toggleDetailModal = (modeSet = "", isPage = false) => {
    if (isPage) {
      history.push("/invoice/all");
      return;
    } else {
      setDetailModal(!detailModal);
    }
  };

  //ROLE_EINVOICE_CUA_HANG thì ẩn nút phát hành
  const [isRoleStore, setIsRoleStore] = useState(false);
  const [isRoleAccountant, setIsRoleAccountant] = useState(false);

  // Action Dispatch
  useEffect(() => {
    const info = jwt_decode(localStorage.getItem(AUTH_TOKEN));
    const roleUser = info["auth"];
    if (roleUser) {
      const listRole = info["auth"].split(",");
      setIsRoleStore(
        listRole.findIndex(item => item === ROLE_EINVOICE_CUA_HANG) !== -1
          ? true
          : false
      );
      setIsRoleAccountant(
        listRole.findIndex(item => item === ROLE_EINVOICE_KE_TOAN) !== -1
          ? true
          : false
      );
    }
  }, []);

  // modalCheckRelease
  const [titleBodyCheckRelease, setTitleBodyCheckRelease] = useState("");
  const [modalCheckRelease, setModalCheckRelease] = useState(false);
  const toggleCheckReleaseModal = () =>
    setModalCheckRelease(!modalCheckRelease);

  // modalDenyRelease
  const [titleBodyDenyRelease, setTitleBodyDenyRelease] = useState("");
  const [modalDenyRelease, setModalDenyRelease] = useState(false);
  const toggleDenyReleaseModal = () => setModalDenyRelease(!modalDenyRelease);

  // modalPDFView
  const [modalPdfView, setModalPdfView] = useState(false);
  const [dataViewDocument, setDataViewDocument] = useState(null);
  const togglePdfViewModal = () => setModalPdfView(!modalPdfView);
  const showPdfById = id => {
    setDataViewDocument({
      id,
    });
    togglePdfViewModal();
  };

  const [isEnterprise, setIsEnterprise] = useState(false);

  const Dashboard = useSelector(state => state.Dashboard);
  const {
    tenantCodeHeader,
    finalBuInfo,
    type: typeDashboard,
    buStoreHeader,
    finalListBuCode,
  } = Dashboard;

  useEffect(() => {
    if (tenantCodeHeader) {
      setIsEnterprise(tenantCodeHeader === TENANT_CODE.GUARDIAN);
    }
  }, [tenantCodeHeader]);

  useEffect(() => {
    setDataDetail({
      id: idDetail,
    });
    toggleDetailModal();
  }, [idDetail]);

  const [mode, setMode] = useState("");
  const [pageView, setPageView] = useState(null);
  const [dataConfirmAction, setDataConfirmAction] = useState(null);
  const setPageViewByRow = row => {
    let pageView = "";
    if (row.invoice_type)
      switch (row.ttchung_khmshdon) {
        // Hóa đơn GTGT
        case "1":
          switch (row.invoice_type) {
            case "1":
              pageView = issueInvoicePageViewList.PAGE_VAT_INVOICE_HAVE_CODE;
              break;
            case "0":
              pageView = issueInvoicePageViewList.PAGE_VAT_INVOICE_NONE_CODE;
              break;
            default:
              break;
          }
          break;
        // Hóa đơn Bán hàng
        case "2":
          switch (row.invoice_type) {
            case "1":
              pageView = issueInvoicePageViewList.PAGE_SALE_INVOICE_HAVE_CODE;
              break;
            case "0":
              pageView = issueInvoicePageViewList.PAGE_SALE_INVOICE_NONE_CODE;
              break;
            default:
              break;
          }
          break;
        default:
          break;
      }
    setPageView(pageView);
  };
  const childRef = useRef();

  return (
    <React.Fragment>
      {/* PDFViewModal */}
      <PDFViewModal
        isOpen={modalPdfView}
        dataViewDocument={dataViewDocument}
        toggle={togglePdfViewModal}
      ></PDFViewModal>
      {/* CheckRelease modal */}
      <ConfirmModal
        isOpen={modalCheckRelease}
        titleHeader={"Xác nhận Phát hành hóa đơn"}
        titleBody={titleBodyCheckRelease}
        onConfirm={note => {
          toggleCheckReleaseModal();
          // phát hành trong detail
          childRef?.current?.releaseFromDetail();
          //   releaseInvoiceFunc(rowRelease);
        }}
        textBtnConfirm={"Xác nhận"}
        textBtnCancel={"Đóng"}
        toggle={toggleCheckReleaseModal}
      />
      {/* CheckRelease modal */}
      <ConfirmModal
        isOpen={modalDenyRelease}
        titleHeader={"Từ chối phát hành hóa đơn"}
        titleBody={titleBodyDenyRelease}
        onConfirm={note => {
          toggleDenyReleaseModal();
        }}
        textBtnConfirm={"Xác nhận"}
        textBtnCancel={"Đóng"}
        toggle={toggleDenyReleaseModal}
      />
      {/* Detail Modal */}
      <DetailInvoice
        ref={childRef}
        isPage={true}
        dataDetail={dataDetail}
        isEnterprise={isEnterprise}
        dataConfirmAction={dataConfirmAction}
        isOpenModal={detailModal}
        toggleModal={toggleDetailModal}
        showPdfById={showPdfById}
        mode={mode}
        pageView={pageView}
        setDataConfirmAction={setDataConfirmAction}
        setPageViewByRow={setPageViewByRow}
        setMode={setMode}
        isRoleStore={isRoleStore}
        isRoleAccountant={isRoleAccountant}
        setTitleBodyDenyRelease={setTitleBodyDenyRelease}
        toggleDenyReleaseModal={toggleDenyReleaseModal}
        setTitleBodyCheckRelease={setTitleBodyCheckRelease}
        toggleCheckReleaseModal={toggleCheckReleaseModal}
        // invoiceSymbolList={invoiceSymbolList.items}
      />
    </React.Fragment>
  );
};

export default DetailInvoicePage;
